import { MouseEvent, useState } from 'react';

import { cx } from '@libs/classnames';
import { Button } from '@ui/components/Button';
import { Card } from '@ui/components/Card';
import { ModalCard } from '@ui/components/ModalCard';

import { NewsList } from '@features/club/ui/NewsList/NewsList';
import { NewsPostCard } from '@features/club/ui/NewsPostCard/NewsPostCard';
import { NewsPost } from '@features/shared/api/typings';

import styles from './ClubNews.module.css';

type Props = {
  className?: string;
  news?: NewsPost[];
  onLoadMore: () => void;
  hasMore: boolean;
};
export function ClubNews({ className, news, onLoadMore, hasMore }: Props) {
  const [fullViewOpen, setFullViewOpen] = useState(false);
  const [newsPostIdOpen, setNewsPostIdOpen] = useState<string | null>(null);

  if (!news || news.length < 1) return null;

  const openNewsPost = news.find((newsPost) => newsPost.id === newsPostIdOpen);

  // TODO preserve scroll list -> modal news list -> news post card

  return (
    <Card flat className={cx(styles.news, className)}>
      <div className={styles.header}>
        <div className={styles.title}>Новости</div>
        <Button
          variant="slim"
          onClick={(e: MouseEvent) => {
            e.stopPropagation();
            setFullViewOpen(true);
          }}
        >
          Смотреть все ›
        </Button>
      </div>

      <NewsList
        news={news.slice(0, 2)}
        onNewsItemClick={(newsPost) => setNewsPostIdOpen(newsPost.id)}
        onLoadMore={onLoadMore}
        hasMore={false}
      />

      {fullViewOpen && !openNewsPost && (
        <ModalCard title="Новости клуба" onClose={() => setFullViewOpen(false)}>
          <NewsList
            className={styles.modalNewsList}
            news={news}
            onNewsItemClick={(newsPost) => setNewsPostIdOpen(newsPost.id)}
            onLoadMore={onLoadMore}
            hasMore={hasMore}
            isModal
          />
        </ModalCard>
      )}

      {newsPostIdOpen && openNewsPost && (
        <ModalCard title="Новости клуба" onClose={() => setNewsPostIdOpen(null)}>
          <NewsPostCard className={styles.modalNewsItem} newsPost={openNewsPost} />
        </ModalCard>
      )}
    </Card>
  );
}
